import React, { useEffect, useState } from 'react';
import IconInfoError from '../icons/icon-info-error.svg';
import userEvent from '@testing-library/user-event';

export interface IInputText {
    className?: string,
	inputClassName?: string,
	label?: string,
	name?: string,
	required?: boolean,
	validateRule?: Function,
	validationError?: string,
	icon?:any,
	onChangeText: Function,
	value: string,
	[other: string | number | symbol]: unknown;
}

export default function InputText({className, inputClassName, label, name, required, validateRule, validationError,onChangeText,icon, ...other} : IInputText) {
	const [valid, setValid] = useState();

	function validate(e:React.ChangeEvent<HTMLInputElement>){
		if(validateRule){
			setValid(validateRule((e.target as HTMLInputElement).value))
		}
	}
	function handelChange(e:React.ChangeEvent<HTMLInputElement>){
		if(onChangeText){
			onChangeText(e)
		}
	}

    return <div className={`${className ? className : ''}`}>
        <label className="input-text__label" htmlFor={name}>
			{required ? `${label} *` : label}
		</label>
		<div className={`input-text__wrapper`}>
			<input className={`margin__top-bottom--xxxs small ${inputClassName ? inputClassName : "input-text" }  input-text--full display--block ${valid === false ? "input-text--error" : ""}`}  
				name={name} 
				required={required} 
				onBlur={validate}
				onChange={handelChange}		
				{...other} />
				{icon && 
					<img src={icon} className="input-text__icon"/>
				}
		</div>
        { valid === false && validationError !== "" &&
			<p className="xsmall error">{validationError}</p>
        }
	</div>
}
